import { useQuery, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import { useAuth } from '../../../hooks/useAuth'

export const useStampCards = () => {
  const { household, user } = useAuth()
  const qc  = useQueryClient()
  const key = ['stamp-cards', household?.id]

  const query = useQuery({
    queryKey: key,
    enabled:  !!household?.id,
    queryFn:  async () => {
      const { data, error } = await supabase
        .from('stamp_cards')
        .select('id, household_id, assigned_to, created_by, name, goal_count, current_count, reward_description, completed_at, linked_task_title')
        .eq('household_id', household.id)
        .order('created_at', { ascending: false })
      if (error) throw error
      return data ?? []
    },
  })

  const inv = () => qc.invalidateQueries({ queryKey: key })

  const createCard = async (fields) => {
    const { error } = await supabase
      .from('stamp_cards')
      .insert({ ...fields, household_id: household.id, created_by: user.id })
    if (error) throw error
    inv()
  }

  const awardStamp = async (card) => {
    const next = Math.min(card.current_count + 1, card.goal_count)
    const { error } = await supabase
      .from('stamp_cards')
      .update({ current_count: next })
      .eq('id', card.id)
    if (error) throw error
    inv()
  }

  const markRedeemed = async (id) => {
    const { error } = await supabase
      .from('stamp_cards')
      .update({ completed_at: new Date().toISOString(), current_count: 0 })
      .eq('id', id)
    if (error) throw error
    inv()
  }

  const deleteCard = async (id) => {
    const { error } = await supabase.from('stamp_cards').delete().eq('id', id)
    if (error) throw error
    inv()
  }

  return { ...query, createCard, awardStamp, markRedeemed, deleteCard }
}
